module.exports = __webpack_public_path__ + "img/friendly-kids.73895917.jpg";